import { IGif } from "@/common/api/services/types";

export const mergeGifs = (existingGifs: IGif[] = [], incomingGifs: IGif[]): IGif[] => {
  const gifMap = new Map<string, IGif>(existingGifs.map((gif) => [gif.id, gif]));

  incomingGifs.forEach((gif) => {
    const oldGif = gifMap.get(gif.id) || {};

    // some properties of gifs as example `repost` dont send in other endpoints
    gifMap.set(gif.id, {
      ...oldGif,
      ...gif,
    });
  });

  return Array.from(gifMap.values());
};
